import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TRANSFORM_AFTER, TRANSFORM_BEFORE } from './salesData';
export function TransformationSection() {
  return <section id="transformacion" className="bg-charcoal py-12 sm:py-16" data-id="element-349" data-mp="2wzgr7ytf572j">
      <div className="mx-auto max-w-4xl px-5" data-id="element-350" data-mp="2ry18weimlenu">
        <div className="text-center" data-id="element-351" data-mp="2nwpfdxwms9ad">
          <SectionTag className="border-gold/50 bg-charcoal-soft text-gold-soft" data-id="element-352" data-mp="2nxr0kv7d2c5t">
            La transformación
          </SectionTag>
          <h2 className="mt-4 font-display text-[1.45rem] font-bold uppercase leading-tight text-ivory sm:text-[2.1rem]" data-id="element-353" data-mp="2j4edipibydf6">
            Del consultorio que trabaja mucho
            <span className="mt-1 block text-gold" data-id="element-354" data-mp="299mfjkku5ojv">al consultorio que deja más</span>
          </h2>
        </div>

        <div className="mt-8 grid items-stretch gap-3 sm:grid-cols-[1fr_auto_1fr]" data-id="element-355" data-mp="2486s5lv6r5yb">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35
        }} className="rounded-2xl border border-ivory/15 bg-charcoal-soft/60 p-5" data-id="element-356" data-mp="207wqgleff1p9">
            <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-ivory/50" data-id="element-357" data-mp="5epscg4hjtml">
              Antes
            </p>
            <ul className="mt-3.5 space-y-2" data-id="element-358" data-mp="y1tpy01915oc">
              {TRANSFORM_BEFORE.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-359" data-mp="130erc2s8lved">
                  <XIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-ivory/40" aria-hidden data-id="element-360" data-mp="12ykelbr4d9ld" />
                  <span className="font-sans text-[0.84rem] leading-snug text-ivory/60" data-id="element-361" data-mp="p2yikkmgxpjg">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <div className="flex items-center justify-center" aria-hidden data-id="element-362" data-mp="39qbiyugmhj3u">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold" data-id="element-363" data-mp="3dsycr0wute3o">
              <ArrowRightIcon className="h-4 w-4 rotate-90 text-ivory sm:rotate-0" data-id="element-364" data-mp="1kailsx296nna" />
            </span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: 0.08
        }} className="rounded-2xl border border-gold/40 bg-charcoal-soft p-5" data-id="element-365" data-mp="1fbxmr0yqma0f">
            <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold" data-id="element-366" data-mp="11l2jc470cl48">
              Después
            </p>
            <ul className="mt-3.5 space-y-2" data-id="element-367" data-mp="rlbrybdqum8d">
              {TRANSFORM_AFTER.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-368" data-mp="mm8k6j6dq1wp">
                  <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-369" data-mp="mo1q1w964i3n" />
                  <span className="font-sans text-[0.84rem] font-medium leading-snug text-ivory" data-id="element-370" data-mp="2lyjp49p6z9x6">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}